export interface BucketSizeItem {
  dateTime: string;
  bucketSize: number;
}

export const bucketSizeMock = [
  { dateTime: "2025-10-01", bucketSize: 1400 },
  { dateTime: "2025-10-05", bucketSize: 1100 },
  { dateTime: "2025-10-10", bucketSize: 1200 },
  { dateTime: "2025-10-15", bucketSize: 900 },
  { dateTime: "2025-10-20", bucketSize: 1000 },
  { dateTime: "2025-10-25", bucketSize: 800 },
  { dateTime: "2025-11-01", bucketSize: 1100 },
  { dateTime: "2025-11-10", bucketSize: 1200 },
  { dateTime: "2025-11-20", bucketSize: 1200 },
  { dateTime: "2025-12-01", bucketSize: 1000 },
];
